export default "__VITE_ASSET__CZnZqz3o__"